import React from "react"
import styled from "styled-components"
import { translate } from "react-i18next"

const Icon = styled.i`
  color: #007f0e;
  font-size: 24px;
`

const WidgetExportDownloadCompleteNotification = ({ closeToast, t }) => {
  return (
    <div className="text-center">
      <div style={{ margin: "5px 0" }}>
        <Icon className="fa fa-check" aria-hidden="true" />
      </div>
      {t("Widgets.Shared.ExportComplete")}
      {/* <button onClick={closeToast}>Cancel download</button> */}
    </div>
  )
}

export default translate()(WidgetExportDownloadCompleteNotification)



// WEBPACK FOOTER //
// ./src/components/layout/widget/WidgetExportDownloadCompleteNotification.jsx